<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div style="display: flex; justify-content: space-between">
          <button class="btn btn-primary" @click="showAddModal">Отдать на ремонт</button>
        </div>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="this.isLoading">
            <CircleProgress/>
          </div>
        </transition>
        <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
          <div v-if="!this.isLoading">
            <Table
                :columns="columns"
                :isRepair="true"
                :data="repairList"
                :deleteAction="deleteFromRepairList"
                :tableName="'Ремонт'"
            />

            <div style="display: flex; justify-content: flex-end; margin-top: 10px;">
              <button class="btn btn-primary" style="margin-right: 10px;" @click="previousPage" :disabled="repairPaginationStart <= 0"><i
                  class="ni ni-bold-left"></i></button>
              <button class="btn btn-primary" @click="nextPage" :disabled="repairListSize > repairList.length"><i
                  class="ni ni-bold-right"></i></button>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <transition name="fade" css="false" @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div v-if="showModal">
        <div class="modal" :class="{ 'd-block': showModal }" id="productModal" tabindex="-1" role="dialog"
             aria-labelledby="productModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="productModalLabel">Отдать на ремонт</h5>
                <b-button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                  <span aria-hidden="true">&times;</span>
                </b-button>
              </div>
              <div class="modal-body">
                  <div class="input-container" style=" margin-top: 16px; position: relative;">
                    <label for="productId">Продукт</label>
                    <input
                        id="productId"
                        v-model="productFilter"
                        type="text"
                        placeholder="Введите продукт"
                        style="max-width: 100%; border: 1px solid #d2d6da; color: #495057; border-radius: 0.5rem; font-size: 0.85rem; padding: 0.5rem 0.75rem;"
                        @input="filterProducts"
                        @focus="showOptions = true"
                        @blur="onBlurHandler"
                    >
                    <ul v-if="showOptions" class="options-list">
                      <li
                          v-for="(product) in filteredProducts"
                          :key="product.id"
                          @click="updateRepairProductId(product)"
                      >
                        {{ product.name }}
                      </li>
                    </ul>
                  </div>

                  <div class="input-container" style=" margin-top: 16px;">
                    <label for="reason">Причина</label>
                    <argon-input
                      id="reason"
                      v-model="createReason"
                      :value="createReason"
                      placeholder="Причина"
                      :isRequired="true"
                      @change="setReason"
                  />
                  </div>

                  <argon-button
                      variant="fill"
                      color="primary"
                      type="submit"
                      @click="createRepair"
                  >{{'Добавить' }}
                  </argon-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CircleProgress from "./components/CircleProgress.vue";
import Table from "./components/Table.vue";
import axios from "@/axios";
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import velocity from "velocity-animate";
import ArgonInput from "../components/ArgonInput.vue";
import ArgonButton from "../components/ArgonButton.vue";

export default {
  name: "RepairTable",
  components: {
    ArgonButton,
    ArgonInput,
    Table,
    CircleProgress
  },
  data() {
    return {
      showOptions: false,
      repairList: [],
      columns: ['ID',
        'Продукт',
        'Дата сдачи в ремонт',
        'Причина',
      ],
      sortOptions: [
        { key: 'null', value: 'null', text: 'Все' },
        { key: 'ASC', value: 'ASC', text: 'От А до Я' },
        { key: 'DESC', value: 'DESC', text: 'От Я до А' },
      ],
      showModal: false,
    };
  },
  computed: {

    filteredProducts() {
      if (!this.productFilter || this.productFilter.trim() === '') {
        return this.products;
      } else {
        return this.products.filter((product) =>
            product.name.toLowerCase().includes(this.productFilter.toLowerCase())
        );
      }
    },


    isLoading: {
      get() {
        return this.$store.state.isRepairLoading;
      },
    },

    repairListSize: {
      get() {
        return this.$store.state.repairListSize;
      }
    },
    repairPaginationStart: {
      get() {
        return this.$store.state.repairPaginationStart
      }
    },
    createReason: {
      get() {
        return this.$store.state.createRepairReason
      }
    },
    productId: {
      get() {
        return this.$store.state.createRepairProductId
      }
    },
    productFilter: {
      get() {
        return this.$store.state.createRepairProductFilter
      }
    },
    products: {
      get() {
        return this.$store.state.repairProducts
      }
    }
  },
  methods: {

    fetchData() {
      this.updateRepairIsLoading(true);
      let url = '/api/product/get-repair-list?length=' + this.repairListSize + "&start=" + this.repairPaginationStart;
      axios.get(url).then(response => {
        let list = response.data.map(repair => {
          return {
            id: repair.id,
            name: repair.product.name,
            repairDate: repair.date,
            reason: repair.description,
          };
        });
        this.repairList = list;
        this.updateRepairIsLoading(false);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
        this.updateRepairIsLoading(false);
      });
    },

    createRepair(){
      let data = {
        productId: this.product.id,
        description: this.createReason
      };
      axios.post('/api/product/add-repair-list', data).then(() => {
        this.showModal = false;
        this.$store.commit('clearRepairProducts');
        this.fetchData();
      }).catch(error => {
        console.error("Ошибка создания ремонта: ", error);
      });
    },
    deleteFromRepairList(item) {
      axios.delete(`/api/product/repair_product/${item.id}`).then(() => {
        this.fetchData();
      });
    },
    getProducts(){
      this.updateRepairIsLoading(true);
      let url = '/api/product'
      axios.get(url).then(response => {
        this.updateProducts(response.data);
      }).catch(error => {
        console.error("Ошибка загрузки данных: ", error);
        this.updateRepairIsLoading(false);
      })
    },
    startSearch() {
      this.fetchData();
    },

    updateProducts(products){
      this.$store.commit('updateRepairProducts', products);
    },

    resetPagination() {
      this.$store.commit('updateRepairPaginationStart', 0);
    },

    showAddModal() {
      this.showModal = true;
    },
    closeModal() {
      this.$store.commit('clearRepairProducts');
      this.showModal = false;
    },
    updateRepairProductId(product) {
      this.$store.commit('updateCreateRepairProductId', product.id);
      this.$store.commit('updateCreateRepairProductFilter', product.name);
      this.showOptions = false;
    },

    nextPage() {
      const currentStep = this.repairPaginationStart + this.repairListSize;
      this.$store.commit('updateRepairPaginationStart', currentStep);
      this.fetchData();
    },
    previousPage() {
      const currentStep = this.repairPaginationStart - this.repairListSize;
      this.$store.commit('updateRepairPaginationStart', currentStep);
      this.fetchData();
    },
    updateRepairIsLoading(active) {
      this.$store.commit('updateRepairIsLoading', active);
    },
    setReason(payload){
      this.$store.commit('updateCreateRepairReason', payload.target.value);
    },
    filterProducts(payload) {
      this.$store.commit('updateCreateRepairProductFilter', payload.target.value);
      this.showOptions = true;
    },
    onBlurHandler() {
      setTimeout(() => {
        this.showOptions = false;
      }, 200);
    },
    beforeEnter(el) {
      el.style.opacity = 0;
    },
    enter(el, done) {
      velocity(el, {opacity: 1}, {duration: 500, complete: done});
    },
    leave(el, done) {
      velocity(el, {opacity: 0}, {duration: 500, complete: done});
    }
  },
  mounted() {
    this.fetchData();
    this.getProducts();
  },
};
</script>
<style scoped>
.input-container {
  display: flex;
  flex-direction: column;
}

.options-list {
  position: absolute;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  padding-left: 0;
  border: 1px solid #d2d6da;
  border-radius: 0.5rem;
  background-color: white;
  z-index: 1;
  top: 100%;
  margin-top: 0.25rem;
}

.options-list li {
  padding: 0.5rem 0.5rem;
  cursor: pointer;
  list-style-type: none;
}

.options-list li:hover {
  background-color: #f8f9fa;
}

</style>
